<template>
  <c-card>
    <c-card-body>
      <h2>User logs</h2>
      <template v-if="isLoading">
        <p class="lead">Loading...</p>
      </template>
      <template v-else>
        <table v-if="userLogs.length" class="table">
          <thead>
            <tr>
              <th class="date">Date</th>
              <th>Action</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in userLogs">
              <td>{{ log.createdAt | dateFormat }}</td>
              <td>{{ log.action }}</td>
              <td>{{ log.description }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else class="text-h6 is-4">There are no user logs.</p>
      </template>
    </c-card-body>
  </c-card>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  props: {
    user: Object,
  },
  data() {
    return {
      error: null,
      userLogs: [],
      isLoading: false,
    };
  },

  mounted() {
    this.get();
  },

  methods: {
    get() {
      this.isLoading = true;
      this.error = null;
      this.$http
        .get(buildEndpoint('user-logs/') + this.user._id)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.userLogs = response.data.data;
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error getting log data',
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error.message,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
table {
  .date {
    width: 200px;
  }
}
</style>
